<template>
  <div id="app" :class="{ 'platform-windows': isWindows, 'browser-ie': isIE }">
    <template v-if="!isWebView">
      <div class="scroll-container" :class="{ active: navOpen }">
        <app-header></app-header>
        <welcome-notice />
        <performance-notice />
        <div id="scrollable" :class="{ blury: navOpen }">
          <loading-animation v-if="!contentLoaded" />
          <router-view v-show="contentLoaded" />
          <app-footer></app-footer>
        </div>
      </div>
    </template>
    <template v-else>
      <router-view />
    </template>
  </div>
</template>

<script lang="ts">
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import AppFooter from '@/components/global/app-footer/AppFooter.vue';
import AppHeader from '@/components/global/app-header/AppHeader.vue';
import PerformanceNotice from '@/components/global/performance-notice/PerformanceNotice.vue';
import WelcomeNotice from '@/components/global/welcome-notice/WelcomeNotice.vue';
import LoadingAnimation from '@/components/shared/loading-animation/LoadingAnimation.vue';
import { isOldIE, isWindows } from '@/utils/platform-detector';

const AppModule = namespace('app');
const UsersModule = namespace('users');
@Component({
  components: {
    AppFooter,
    AppHeader,
    LoadingAnimation,
    PerformanceNotice,
    WelcomeNotice,
  },
  name: 'app',
})
export default class App extends Vue {
  @AppModule.State('navOpen') public navOpen!: boolean;
  @AppModule.State('activeLanguage') public activeLanguage!: string;
  @AppModule.State('contentLoaded') public contentLoaded!: boolean;
  @AppModule.State('isWebView') public isWebView!: boolean;
  @UsersModule.State('user') public user!: object;

  public isWindows: boolean = isWindows();
  public isIE: boolean = !!isOldIE();
  public created() {
    this.initAppShadow();
  }

  public beforeDestroy() {
    window.document.removeEventListener('scroll', this.addShadowClass);
  }

  private initAppShadow() {
    window.setTimeout(() => {
      this.addShadowClass();
      window.document.addEventListener('scroll', this.addShadowClass);
    }, 100);
  }

  private getScrollTop() {
    if (typeof window.pageYOffset !== 'undefined') {
      return window.pageYOffset;
    } else {
      const B = document.body; // IE 'quirks'
      let D = document.documentElement; // IE with doctype
      D = D.clientHeight ? D : B;
      return D.scrollTop;
    }
  }

  private addShadowClass() {
    const mainNavBar = window.document.getElementById('main-nav-bar');
    if (!mainNavBar) {
      return;
    }

    const scrollTop = this.getScrollTop();
    if (scrollTop >= 20 && !mainNavBar.classList.contains('shadow')) {
      mainNavBar.classList.add('shadow');
    } else if (scrollTop <= 20 && mainNavBar.classList.contains('shadow')) {
      mainNavBar.classList.remove('shadow');
    }
  }
}
</script>

<style src="./app.main.scss" lang="scss"></style>
